import { render } from "./SongsBox.vue?vue&type=template&id=8075c97a"
import script from "./SongsBox.vue?vue&type=script&lang=js"
export * from "./SongsBox.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__